import {
  EnvelopeRecipientStatus,
  StakeholderType,
} from '@urbanx/agx-ui-components';
import type { EnvelopeSubmissionRecipient } from '@urbanx/agx.campaigns.client';

export const allSigned = (
  recipients: EnvelopeSubmissionRecipient[],
  stakeHolderType: StakeholderType
) => {
  const stakeHolders = recipients.filter(
    x => x.stakeholderType === stakeHolderType
  );
  const validStatuses = [
    EnvelopeRecipientStatus.Signed,
    EnvelopeRecipientStatus.Complete,
  ];
  return (
    stakeHolders.length > 0 &&
    stakeHolders.every(x => validStatuses.includes(x.status!))
  );
};
